var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3C9.67279 3 10.0092 3 10.4131 3.30997C10.5171 3.38977 10.6102 3.48286 10.69 3.58686C11 3.99082 11 4.57721 11 5.75V8C11 9.41421 11 10.1213 10.5607 10.5607C10.1213 11 9.41421 11 8 11H4C2.58579 11 1.87868 11 1.43934 10.5607C1 10.1213 1 9.41421 1 8V5.75C1 4.57721 1 3.99082 1.30997 3.58686C1.38977 3.48286 1.48286 3.38977 1.58686 3.30997C1.99082 3 2.32721 3 3.5 3",
    stroke: "#62626A",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.5L8.05709 2.39272C7.86599 1.91498 7.6997 1.37305 7.20832 1.12978C6.9462 1 6.6308 1 6 1C5.3692 1 5.0538 1 4.79168 1.12978C4.3003 1.37305 4.13401 1.91498 3.94291 2.39272L3.5 3.5",
    stroke: "#62626A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 7C7.75 7.9665 6.9665 8.75 6 8.75C5.0335 8.75 4.25 7.9665 4.25 7C4.25 6.0335 5.0335 5.25 6 5.25C6.9665 5.25 7.75 6.0335 7.75 7Z",
    stroke: "#62626A",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 3H6.00439",
    stroke: "#62626A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.0432f1cce49e8a0eee12306e74ec30f9.svg";
export { ForwardRef as ReactComponent };